import QueryString from "qs"
import http from "../index"
import {
  apiGetReportVnpt,
  apiGetDetailReportVnpt,
  apiImportVinaSim,
  apiGetReportSimVnpt,
  apiGetReportWallet,
  apiGetDetailWalletReport,
  apiGetReportBuyPoolData,
  apiGetReportSalePoolData,
  apiGetDetailReportSalePoolData,
  apiGetDetailReportPurchasePoolData,
  apiExportExcelExcelPurchaseReportPoolData,
  apiExportExcelExcelSaleReportPoolData,
  apiGetReportInventoryPoolData,
  apiGetDetailReportInventoryPoolData,
  apiGetReportPackageInventoryM2M,
  apiGetDetailReportPackageInventoryM2M,
  apiGetReportPoolWallet,
  apiGetDetailReportPoolWallet,
  apiUpdateReportPoolWallet,
  apiGetReportPackageReceiptM2M,
  apiGetDetailReportPackageReceiptM2M,
  apiGetReportPackageOrderM2M,
  apiGetDetailReportPackageOrderM2M,
  apiExcelReportPackageOrderM2M,
  apiExcelReportPackageReceiptM2M,
  apiExportReportPackageInventoryM2M,
  apiExportReportData,
  apiExportReportSimInventory,
  apiExportExcelWallet,
  apiGetGeneralReportPoolData,
  apiGetReportCustomer,
  apiGetDetailReportCustomer,
  apiReportCustomer,
  apiGetSimDetailReportVnpt
} from "./urls"

const getReportVnpt = params => http.get(apiGetReportVnpt, { params })
const getReportSimVnpt = params => http.get(apiGetReportSimVnpt, { params })
const getSimDetailReportVnpt = (id, params) => http.get(apiGetSimDetailReportVnpt(id), { params });
const getDetailReportVnpt = id => http.get(apiGetDetailReportVnpt(id))
const importVinaSim = body => http.post(apiImportVinaSim, body)
const getReportWallet = params => http.post(apiGetReportWallet, { params })
const getDetailWalletReport = id => http.get(apiGetDetailWalletReport(id))
const getReportBuyPoolData = params =>
  http.get(apiGetReportBuyPoolData, { params })
const getReportSalePoolData = params =>
  http.get(apiGetReportSalePoolData, { params })
const getDetailSaleReportPoolData = id => http.get(apiGetDetailReportSalePoolData(id))
const getDetailReportPurchasePoolData = id => http.get(apiGetDetailReportPurchasePoolData(id))
const exportExcelPurchaseReportPoolData = (param) => http.get(apiExportExcelExcelPurchaseReportPoolData, { params: param, responseType: "blob" })
const exportExcelSaleReportPoolData = (param) => http.get(apiExportExcelExcelSaleReportPoolData, { params: param, responseType: "blob" })
const getReportInventoryPoolData = params =>
  http.get(apiGetReportInventoryPoolData, { params })
const getDetailInventoryReportPoolData = id => http.get(apiGetDetailReportInventoryPoolData(id))
const getReportPackageInventoryM2M = params =>
  http.get(apiGetReportPackageInventoryM2M, { params })
const getDetailReportPackageInventoryM2M = id => http.get(apiGetDetailReportPackageInventoryM2M(id))
const getReportPoolWallet = params =>
  http.get(apiGetReportPoolWallet, { params })
const getDetailReportPoolWallet = id => http.get(apiGetDetailReportPoolWallet(id))
const updateReportPoolWallet = (id, body) => http.put(apiUpdateReportPoolWallet(id), body)
const getReportPackageReceiptM2M = params =>
  http.get(apiGetReportPackageReceiptM2M, { params })
const getDetailReportPackageReceiptM2M = id => http.get(apiGetDetailReportPackageReceiptM2M(id))
const exportExcelReportPackageReceiptM2M = (param) => http.get(apiExcelReportPackageReceiptM2M, { params: param, responseType: "blob" })
const getReportPackageOrderM2M = params =>
  http.get(apiGetReportPackageOrderM2M, { params })
const getGeneralReportPoolData = params =>
  http.get(apiGetGeneralReportPoolData, { params })
const getDetailReportPackageOrderM2M = id => http.get(apiGetDetailReportPackageOrderM2M(id))
const exportExcelReportPackageOrderM2M = (param) => http.get(apiExcelReportPackageOrderM2M, { params: param, responseType: "blob" })
const exportReportPackageInventoryM2M = (param) => http.get(apiExportReportPackageInventoryM2M, { params: param, responseType: "blob" })
const exportExcelReportData = (param) => http.get(apiExportReportData, { params: param, responseType: "blob" })
const exportExcelReportCustomer = (param) => http.get(apiReportCustomer, { params: param, responseType: "blob" })
const exportExcelReportSimInventory = (param) => http.get(apiExportReportSimInventory, { params: param, responseType: "blob" })
const exportExcelWallet = (param) => http.get(apiExportExcelWallet, { params: param, responseType: "blob" })
const getReportCustomer = params => http.get(apiGetReportCustomer, { params })
const getDetailReportCustomer = id => http.get(apiGetDetailReportCustomer(id))

const ReportPoolDataService = {
  getReportVnpt,
  importVinaSim,
  getDetailReportVnpt,
  getReportSimVnpt,
  getReportWallet,
  getDetailWalletReport,
  getReportBuyPoolData,
  getReportSalePoolData,
  getDetailSaleReportPoolData,
  getDetailReportPurchasePoolData,
  exportExcelPurchaseReportPoolData,
  exportExcelSaleReportPoolData,
  getReportInventoryPoolData,
  getDetailInventoryReportPoolData,
  getReportPackageInventoryM2M,
  getDetailReportPackageInventoryM2M,
  getReportPoolWallet,
  getDetailReportPoolWallet,
  updateReportPoolWallet,
  getReportPackageReceiptM2M,
  getDetailReportPackageReceiptM2M,
  getReportPackageOrderM2M,
  getDetailReportPackageOrderM2M,
  exportExcelReportPackageReceiptM2M,
  exportExcelReportPackageOrderM2M,
  exportReportPackageInventoryM2M,
  exportExcelReportData,
  exportExcelReportSimInventory,
  exportExcelWallet,
  getGeneralReportPoolData,
  getReportCustomer,
  getDetailReportCustomer,
  exportExcelReportCustomer,
  getSimDetailReportVnpt
}
export default ReportPoolDataService
